export default __webpack_public_path__ + "static/media/img3.3345a6ee.jpg";